import React from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { RefreshCw } from 'lucide-react';
import { clearHolidayCache, clearAllHolidayCache } from '@/lib/scheduling/holidays';
import { toast } from '@/hooks/ui/use-toast';

interface HolidayCacheManagerProps {
  countryCode?: string | null;
}

export default function HolidayCacheManager({ countryCode }: HolidayCacheManagerProps) {
  const handleClearCache = () => {
    if (countryCode) {
      clearHolidayCache(countryCode, new Date().getFullYear());
      toast.success("Cache Cleared", {
        description: `Holiday cache cleared for ${countryCode} ${new Date().getFullYear()}`,
      });
    } else {
      clearHolidayCache();
      toast.success("Cache Cleared", {
        description: "All holiday cache cleared",
      });
    }
  };

  const handleClearAllCache = async () => {
    try {
      await clearAllHolidayCache();
      toast.success("All Cache Cleared", {
        description: "All holiday caches (memory and database) cleared successfully",
      });
    } catch (error) {
      toast.error("Error", {
        description: "Failed to clear all caches",
      });
    }
  };

  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-3 flex-shrink-0">
        <CardTitle className="text-sm font-medium flex items-center gap-2">
          <RefreshCw className="w-5 h-5" />
          Holiday Cache Management
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <p className="text-sm text-muted-foreground">
          If holidays are showing incorrect dates, clear the cache to refresh from Google Calendar.
        </p>
        
        <div className="flex gap-2">
          <Button onClick={handleClearCache} variant="outline" size="sm">
            Clear {countryCode ? `${countryCode} ` : ''}Cache
          </Button>
          
          <Button onClick={handleClearAllCache} variant="outline" size="sm">
            Clear All Cache
          </Button>
        </div>
        
        <p className="text-xs text-muted-foreground">
          Current country: {countryCode || 'Not detected'}
        </p>
      </CardContent>
    </Card>
  );
}